const currencyFormatToEUR = (value, clanica = false) => {
  // Check if the value is a valid number
  if (isNaN(value)) {
    return "Napačna vrednost";
  }

  // If the value is null or undefined and it's related to a clanica, return "Nepopolni podatki"
  if ((value === null || value === undefined) && clanica) {
    return "Nepopolni podatki";
  }

  if (value === null || value === undefined) {
    return "Ni podatka";
  }

  return new Intl.NumberFormat("sl-SI", {
    style: "currency",
    currency: "EUR",
  }).format(value);
};

export default currencyFormatToEUR;
